<template>
  <b-overlay :show="showLoading">
    <b-row>

      <b-col cols="12">
        <b-card>

<!--          <b-form-group-->
<!--              label="تاریخ و زمان پایان Cache"-->
<!--              label-for=""-->
<!--          >-->
<!--            <input-->
<!--                :id="`start${1}`"-->
<!--                :value="createJalaliDate(cacheTime)"-->
<!--                class="form-control form-control-lg w-11/12 2xl:h-12 h-10 mx-auto mb-1 text-sm block w-full rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0 placeholder-inputPlaceHolder text-gray-700"-->
<!--                placeholder="تاریخ و زمان پایان Cache"-->
<!--                type="text"-->
<!--            />-->
<!--            <custom-date-picker-->
<!--                v-model="cacheTime"-->
<!--                :element="`start${1}`"-->
<!--                :min="new Date(Date.now())"-->
<!--                auto-submit-->
<!--                class=""-->
<!--                color="#5c6bc0"-->
<!--                display-format="jYYYY/jMM/jDD HH:mm"-->
<!--                format="YYYY-MM-DD HH:mm"-->
<!--                input-format="YYYY-MM-DD HH:mm"-->
<!--                type="datetime"-->
<!--            ></custom-date-picker>-->
<!--          </b-form-group>-->

          <b-alert
              :show="true"
              variant="warning"
              class="col-12"
          >
            <div class="alert-body mt-2">
              <feather-icon
                  class="mr-25"
                  icon="InfoIcon"
              />
              <span class="ml-25">توجه داشته باشید که با زدن دکمه زیر Cache سایت به مدت 5 ساعت غیرفعال خواهد شد.</span>
            </div>
          </b-alert>

          <!-- Action Buttons -->
          <b-button
              variant="primary"
              class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="updateData()"
          >
            غیرفعال سازی Cache
          </b-button>

        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BMedia, BAvatar, BOverlay, BFormTextarea, BFormGroup, BAlert
} from 'bootstrap-vue'

import {UsersGetDisableCacheRequest, UsersSetDisableCacheRequest} from "@/libs/Api/Users";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  name: "CacheSystem",
  title: 'تنظیمات Cache - پنل ادمین رها مزون',
  data(){
    return{
      cacheTime:null,
      showLoading:false,
    }
  },
  async created(){
    await this.getData();
  },
  methods:{
    async getData(){
      let _this = this;
      _this.showLoading = true;

      let usersGetDisableCacheRequest = new UsersGetDisableCacheRequest(_this);
      await usersGetDisableCacheRequest.fetch(function (content){
        _this.showLoading = false;
        _this.cacheTime = content.data;
      },function (error){
        _this.showLoading = false;
      })
    },
    async updateData(){
      let _this = this;
      _this.showLoading = true;

      let usersSetDisableCacheRequest = new UsersSetDisableCacheRequest(_this);
      // usersSetDisableCacheRequest.setParams({ input : _this.cacheTime })
      await usersSetDisableCacheRequest.fetch(function (content){
        _this.showLoading = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        _this.getData();
      },function (error){
        _this.showLoading = false;
      })
    },
    createJalaliDate(param) {
      if (param !== null && param !== '') {
        return new Date(param).toLocaleDateString("fa-IR",{day:'numeric',month:'numeric',year:'numeric',hour:'numeric',minute:'numeric'});
      }
    },
  },
  components:{
    BAlert,
    BCard,
    BRow,
    BCol,
    BButton,
    BMedia,
    BAvatar,
    BOverlay,
    BFormTextarea,
    BFormGroup
  },
}
</script>

<style scoped>

</style>
